<template>
  <logo css-class="logo" />
</template>

<script>
import logo from '~/components/icons/logo/Logo'

export default {
  components: {
    logo,
  },
}
</script>

<style lang="scss">
.logo {
  height: 24px;
  width: auto;
  fill: #005baa;
}

@media (min-width: 992px) {
  .logo {
    height: 36px;
  }
}
</style>
